import axios from 'axios';
import apiConfig from '../../api.config';

export default function send2fa(lang) {
  const {
    host,
    URIs: { send2fa },
  } = apiConfig;

  const uri = `${host}${send2fa}`;

  return axios
    .post(uri, JSON.stringify({ lang }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
